import { render, staticRenderFns } from "./Recaptcha.vue?vue&type=template&id=002f81c6&scoped=true"
import script from "./Recaptcha.vue?vue&type=script&lang=js"
export * from "./Recaptcha.vue?vue&type=script&lang=js"
import style0 from "./Recaptcha.vue?vue&type=style&index=0&id=002f81c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f81c6",
  null
  
)

export default component.exports